// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1UdiD","wrapperInverted":"styles_wrapperInverted__2AAJI","rotated":"styles_rotated__fVM9R","rotatedBack":"styles_rotatedBack__3Bm2d"};